import { memo } from 'react';

import { cn } from '@air/utils-tailwind';

import { useMainSideNavStore } from '~/components/v2/store/features/workspace/useMainSideNavStore';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

/**
 * Same paint and `duration-200` fade as `WorkspaceNavOverlayScrim`. The page scrim cannot
 * cover this body-portaled card; this layer only covers the card. It is anchored to the
 * inner `overflow-hidden` shell and uses `rounded-12` (the ui2026 card radius) so the fade
 * stops on that curve. A square fade fills the corner wedges and reads as a second corner
 * on the page ground.
 * Opacity is toggled in CSS from the rail's overlay flags so both dimmers start in the same style pass.
 */
export const PrivateWorkspaceAgentPanelNavOverlayDimmer = memo(() => {
  const { ui2026 } = useTemporaryFeatureFlags();
  const isPinned = useMainSideNavStore((state) => state.pinned);

  if (!ui2026) {
    return null;
  }

  return (
    <div
      aria-hidden
      className={cn(
        'pointer-events-none absolute inset-0 z-1 rounded-12 bg-black/10 opacity-0 transition-opacity duration-200 dark:bg-black/40',
        !isPinned &&
          '[:has([data-hover-expand])_&]:opacity-100 [:has([data-main-side-nav]_[data-state=open])_&]:opacity-100',
      )}
      data-testid="WORKSPACE_AGENT_PANEL_NAV_OVERLAY_DIMMER"
    />
  );
});

PrivateWorkspaceAgentPanelNavOverlayDimmer.displayName = 'PrivateWorkspaceAgentPanelNavOverlayDimmer';
